import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { dataesalab } from "../constants";
import "../slider.css"
import { useMediaQuery } from "react-responsive";
import Slider from "react-slick";
import { Link } from "react-router-dom";

export default function SliderComp(props){
    const isMobile = useMediaQuery({ query: `(max-width: 760px)` });
    var settings = {
        dots: false,
        autoplay: false,
        autoplaySpeed: 2500,
        cssEase: "ease-out",
        infinite:true,
        arrows:true,
        speed: 1000,
        slidesToShow: props.customstyles?isMobile?3:5:isMobile?2:3,
        slidesToScroll: isMobile?1:props.slidesToScroll?props.slidesToScroll:1,
      };
    function handleClick(event,index){
        event.preventDefault();
        props.setInd(index);
        props.setQuick(true);
    }

    return <div ref={props.refer} className="sliderdivmain" id={props.arrows?"marginchange":null}>
        <h1 className="sliderTitle">{props.title}</h1>
        <Slider {...settings}>
        {
            props.pictures?props.pictures.map((onepic,index)=>{
                return (<div className="sliderwrapper" style={props.customstyles?{height:"5.5vw"}:null}>
                <img alt="logos" src={onepic} className="sliderimage" style={props.customstyles?{width:isMobile?"15vw":index==1?"12vw":"7vw",height:isMobile?"12vw":"6vw",marginRight:"8vw"}:null}/>
                </div>)
            }):dataesalab.map((val,index)=>{
            if(index<=props.upperrange && index>=props.lowerrange && !props.pictures){
                return <div className="sliderwrapper" id="bigman">
                    <img alt="tests" src={val.imgurl} className="sliderimage" id="dullbg"/>
                    <div className="carddata">
                        <p className="slidertextOne">{val.Title.split(" ").splice(0,2).join(" ")}</p>
                        <p className="slidertextTwo">{val.Price}</p>
                        <Link className="sliderlink" onClick={(event)=>handleClick(event,index)}>Add to Booking</Link>
                    </div>
                </div>
            }else{
                return null;
            }

        })
        }
    </Slider>
    </div>
}   